import zxcvbn from 'zxcvbn';

import { MINIMUM_PASSWORD_SCORE } from '../../constants';

export const validatePasswordStrength = (value = '') => {
  const {
    feedback: {
      warning,
    },
    score,
  } = zxcvbn(value);
  const isValid = score >= MINIMUM_PASSWORD_SCORE;
  const errorMessage = warning || 'avoid common passwords';
  return {
    isValid,
    error: {
      message: errorMessage,
    },
  };
};
